import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesGroups = {
  description: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageGroupsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesGroups}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageGroupsInitializer.displayName = 'Page groups initializer component';

export default PageGroupsInitializer;
